import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import UserApi from '../../../API/user/user-api';
import { addUser } from '../../../actions/user';
import { WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { H1 } from '../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../constans';
import AuthInput from './AuthInput';
import styles from './styles.module.scss';

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState({ username: '', password: '' });

  const clickLogin = async () => {
    UserApi.login({ data: { login: data.username, password: data.password } })
      .then(async res => {
        dispatch(addUser(res.user));
        if (res.user.access.shipments) {
          navigate('/shipment/shipments', { replace: true });
        } else {
          navigate('/user/profile', { replace: true });
        }
      })
      .catch(e => console.log('error: 1', e));
  };

  return (
    <Content centerContent={true}>
      <WhiteBlock className={styles.login_form}>
        <H1 style={{ marginBottom: '20px' }}>Авторизация</H1>
        <AuthInput
          value={data.username}
          onChange={v => setData({ ...data, username: v })}
          style={{ marginBottom: '15px' }}
        />
        <AuthInput value={data.password} onChange={v => setData({ ...data, password: v })} password={true} />
        <Button type={TYPE_BUTTONS.BLUE} style={{ width: '100%', marginTop: '30px' }} onClick={clickLogin}>
          Войти
        </Button>
      </WhiteBlock>
    </Content>
  );
};

export default LoginPage;
